import { ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui";

export function TermsGate({ onAccepted, onLogout }: { onAccepted: () => void; onLogout: () => void }) {
  const [t, setT] = useState<any>(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/me/terms").then((r) => setT(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const accept = async () => {
    setBusy(true);
    try { await api.post("/me/accept-terms"); toast.success("Ketentuan disetujui"); onAccepted(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!t) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Memuat ketentuan…</div>;
  return (
    <div className="min-h-screen bg-background max-w-md mx-auto flex flex-col" data-testid="terms-gate">
      <header className="bg-[hsl(var(--sidebar))] text-white px-5 pt-8 pb-6 rounded-b-3xl">
        <ShieldCheck className="h-8 w-8 text-emerald-400" />
        <h1 className="mt-3 text-2xl font-display font-bold leading-tight">Ketentuan Penggunaan Portal Siswa</h1>
        <p className="text-sm text-white/70 mt-1">{t.org} · versi {t.version}</p>
      </header>
      <main className="flex-1 px-5 py-5">
        <p className="text-sm text-muted-foreground mb-3">Sebelum melanjutkan, baca dan setujui ketentuan berikut. Persetujuan ini tercatat bersama waktu dan perangkat Anda.</p>
        <ol className="space-y-3">
          {t.items.map((s: string, i: number) => (
            <li key={i} className="flex gap-3 text-sm leading-relaxed rounded-xl border bg-card p-3" data-testid={`terms-item-${i}`}>
              <span className="h-6 w-6 shrink-0 grid place-items-center rounded-full bg-[hsl(var(--sidebar))] text-white text-xs font-bold num">{i + 1}</span>
              <span>{s}</span>
            </li>
          ))}
        </ol>
      </main>
      <footer className="sticky bottom-0 bg-background/95 backdrop-blur border-t px-5 py-4 space-y-3">
        <label className="flex items-start gap-3 text-sm cursor-pointer" data-testid="terms-checkbox-label">
          <input type="checkbox" className="mt-1 h-4 w-4" checked={checked} onChange={(e) => setChecked(e.target.checked)} data-testid="terms-checkbox" />
          <span>Saya telah membaca, memahami, dan <b>menyetujui</b> seluruh ketentuan di atas.</span>
        </label>
        <Button className="w-full" disabled={!checked || busy} onClick={accept} data-testid="terms-accept-button">Setuju & Lanjutkan</Button>
        <button type="button" className="w-full text-xs text-muted-foreground" onClick={onLogout} data-testid="terms-decline-button">Tidak setuju — keluar</button>
      </footer>
    </div>
  );
}
